import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import { Link } from 'react-router-dom';
import Truck from './Equipment/Truck';
import {withStyles} from "@material-ui/core";
import { EQUIPMENT_TYPE_IDS } from "../libs/equipment";

const styles = () => {
	return {
		container : {
			width: '100%',
			tableLayout: 'auto',
		},
		card: {
			maxWidth: 240,
			minHeight: 80,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		}
	};
};


class Equipment extends Component {
	render() {
		const { classes, match, ...other } = this.props;

		const equipmentTypeId = _.get(match, 'params.equipmentTypeId');
		if (equipmentTypeId === EQUIPMENT_TYPE_IDS.truck) {
			return <Truck {...other} />
		}

		return (
			<div className={classes.container}>
				<Link to={`/equipment/${EQUIPMENT_TYPE_IDS.truck}`}>
					<Card classes={{root: classes.card }}>Trucks</Card>
				</Link>
			</div>
		);
	}
}

Equipment.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Equipment);
